import {asset} from 'imba';
import url from './service.jpg';
export default asset({
	url: url,
	type: 'image',
	width: 2036,
	height: 823,
	toString: function(){ return this.url;}
})